import React from 'react';

function ConfirmDialog({ message, onConfirm, onCancel }) {
    return (
        <div className="modal-overlay">
            <div className="modal">
                <h3>⚠️ Confirmation Required</h3>
                <p>{message}</p>
                <div className="modal-actions">
                    <button 
                        className="modal-btn secondary"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button 
                        className="modal-btn primary"
                        onClick={onConfirm}
                    >
                        Print Anyway
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ConfirmDialog;
